<script setup lang="ts">
import { CustomMarker } from 'vue3-google-map';
import MapSok from '@files/map-sok.svg?component';
const {
    offsetX = 0,
    offsetY = 0,
    alignment = 'TOP_CENTER',
    zIndex = 50,
    isFocused,
    item,
    hidePrice,
    map,
} = defineProps<IProps>();
const emit = defineEmits<{
    mouseover: [event: MouseEvent];
    mouseleave: [event: MouseEvent];
    click: [event: PointerEvent];
}>();
interface IProps {
    item: any;
    offsetX?: number;
    offsetY?: number;
    alignment?:
        | 'CENTER'
        | 'TOP_CENTER'
        | 'BOTTOM_CENTER'
        | 'LEFT_CENTER'
        | 'RIGHT_CENTER'
        | 'TOP_LEFT'
        | 'TOP_RIGHT'
        | 'BOTTOM_LEFT'
        | 'BOTTOM_RIGHT';
    zIndex?: number;
    isFocused?: boolean;
    map: google.maps.Map;
    hidePrice?: boolean;
}

const marker = computed(() => ({
    lat: item.latitude,
    lng: item.longitude,
}));
const price = computed(() =>
    hidePrice
        ? item.title
        : formatMoney(item.payable || 0, {
              unitClassName: 'small',
          })
);
</script>

<template>
    <CustomMarker
        :options="{
            offsetX,
            offsetY,
            zIndex,
            position: marker,
            anchorPoint: alignment,
            map,
        }"
    >
        <div class="hotel-marker-container">
            <mr-button
                class="price-button"
                :class="{ 'is-focused': isFocused }"
                @mouseover="emit('mouseover', $event)"
                @mouseleave="emit('mouseleave', $event)"
                @click="emit('click', $event)"
            >
                <span v-html="price" />
                <MapSok class="sok" />
            </mr-button>
        </div>
    </CustomMarker>
</template>

<style lang="scss" scoped>
:fullscreen {
    .hotel-card {
        display: flex !important;
    }
}
.hotel-marker-container {
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: column;
    &:hover {
        :deep(.sok) {
            path {
                transition: all 200ms;
                fill: usePalette($p-blue, $p-500) !important;
            }
        }
    }
}

.price-button {
    z-index: 1;
    overflow: visible;
    &.is-focused {
        background: usePalette($p-blue, $p-500) !important;
    }
}

.hotel-card {
    display: none;
    position: absolute;
    top: -116px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
}

.sok {
    position: absolute;
    bottom: -12px;
    align-self: center;
    margin-top: -3px;
    margin-inline: auto;
}
</style>
